// initial state
// shape: [{ id, quantity }]
const state = {}

// getters
const getters = {
  // demoTable: state => state.table
}

// actions
const actions = {
  getFairRewardTable ({commit, state}, params) {
    let promised = request.alert('getFairRewardTable', params)
    return promised
  },
  addRewardLogistics ({commit, state}, params) {
    let promised = request.alert('addRewardLogistics', params)
    return promised
  },
  getLogisticsCompany ({commit, state}, params) {
    let promised = request.alert('getLogisticsCompany', params)
    return promised
  },
  getRewardLogistics ({commit, state}, id) {
    let promised = request.alert('getRewardLogistics', id)
    return promised
  },

}

// mutations
const mutations = {}

export const fairReward = {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/fair-reward/fairReward.store.js